import React from "react";
import { Table as AntTable } from "antd";
import { ExtraButtons } from "src/components/extra-buttons";
import { TableSearch } from "src/components/table-search";
import { Header } from "src/components/layout/header";
import { VisibilityProvider } from "src/components/visibility-provider";
import { useUpdateHeaderTitle } from "src/hooks/use-update-header-title";
import { usePermission } from "src/hooks";
import { EditDrawer } from "src/pages-lib/product-categories/edit-drawer";
import { useGetCategories, useManageItems } from "src/pages-lib/product-categories/model";
import { getFormattedItems } from "src/pages-lib/product-categories/model/use-get-categories";
import { getColumns } from "src/pages-lib/product-categories/table-columns";
import styled from "styled-components";
import {CloudSyncOutlined, CompassOutlined} from "@ant-design/icons";
import {Button} from "../components/actions/button";

export default function ProductCategories() {
  const [createDrawerState, setCreateDrawerState] = React.useState(false);
  const [editDrawerState, setEditDrawerState] = React.useState(false);

  // const [filterDrawerState, setFilterDrawerState] = React.useState(false)
  // const [sortableDrawerState, setSortableDrawerState] = React.useState(false)

  const {
    items: dataCategories,
    refetch: getItems,
    pagination,
    isLoading,
    handleTableChange,
    handleSearch,
    options,
  } = useGetCategories();
  const { hasPermission } = usePermission();

  const { editData, onSaveEdit, onCreate, onDelete, onEditItem, updateToCrm } = useManageItems(
    dataCategories,
    getItems,
    onSuccessEdit,
  );

  const headerTitle = useUpdateHeaderTitle({
    items: dataCategories,
    count: pagination?.total,
    defaultTitle: "0 Категорий",
    arrType: ["Категория", "Категории", "Категорий"],
  });

  const columns = getColumns(hasPermission("product-categories.edit") ? onEditItem : null, hasPermission("product-categories.delete") ? onDelete : null);

  function onSuccessEdit() {
    setEditDrawerState(!editDrawerState);
  }

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            //onCreate={() => setCreateDrawerState(!createDrawerState)}
            // onFilter={() => setFilterDrawerState(!filterDrawerState)}
            // onSort={() => setSortableDrawerState(!sortableDrawerState)}
            //titles={{ onCreate: "Добавить Категорию" }}
          />
        }
      />

        <Toolbar>
          <TableSearch
              handleSearch={handleSearch}
              placeholder={"Поиск по ID, названию, слагу или guid"}
          />

          <StyledButton color={"#808080"} onClick={() => updateToCrm()} icon={
              <CloudSyncOutlined style={{ fontSize: "16px"}}/>}>
              {"Синхронизация категорий" }
          </StyledButton>
        </Toolbar>

        <StyledTable
        rowKey={"id"}
        loading={isLoading}
        dataSource={getFormattedItems(dataCategories, options.categoryOptions)}
        columns={columns}
        pagination={pagination}
        onChange={handleTableChange}
      />

      {hasPermission("product-categories.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <EditDrawer
            onSave={onCreate}
            onClose={() => setCreateDrawerState(!createDrawerState)}
            title={"Создание категории"}
            cityOptions={options.cityOptions}
            categoryOptions={options.categoryOptions}
          />
        </VisibilityProvider>
      )}

      {hasPermission("product-categories.edit") && (
        <VisibilityProvider visible={editDrawerState}>
          <EditDrawer
            onSave={onSaveEdit}
            onClose={() => setEditDrawerState(!editDrawerState)}
            initialValues={editData}
            title={"Редактирование категории"}
            cityOptions={options.cityOptions}
            categoryOptions={options.categoryOptions}
          />
        </VisibilityProvider>
      )}
    </>
  );
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`;

// Поиск и синхронизация — одна панель над таблицей: по отдельности они висели между шапкой
// и таблицей каждый со своим отступом, и поиск читался как ни к чему не привязанный.
const Toolbar = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
`;

const StyledButton = styled(Button)`
    flex-shrink: 0;
    margin-left: auto;
`;


